import * as types from "./mutation_types";

export const resetFormFacture = ({ commit }) => {
  commit(types.GENERAL_RESET_FORM_FACTURE);
};

export const resetFormBordereau = ({ commit }) => {
  commit(types.GENERAL_RESET_FORM_BORDEREAU);
};

export const resetFormContrat = ({ commit }) => {
  commit(types.GENERAL_RESET_FORM_CONTRAT);
};

export const resetFormTier = ({ commit }) => {
  commit(types.GENERAL_RESET_FORM_TIER);
};

export const resetFormMarche = ({ commit }) => {
  commit(types.GENERAL_RESET_FORM_MARCHE);
};

export const resetFormCommande = ({ commit }) => {
  commit(types.GENERAL_RESET_FORM_COMMANDE);
};

export const resetFormOd = ({ commit }) => {
  commit(types.GENERAL_RESET_FORM_OD);
};

export const resetFormMission = ({ commit }) => {
  commit(types.GENERAL_RESET_FORM_MISSION);
};
export const resetFormAutreDocumentComptable = ({ commit }) => {
  commit(types.GENERAL_RESET_FORM_AUTREDOCUMENTCOMPTABLE);
};
